export const FormSamplesWithinDialogPageInfo = () => {
  return (
    <>
        This example shows how to make use of the form within a Dialog. <br />
        Unlike other forms, the buttons sit within the DialogActions and not in the Form component.<br />
        This is so the buttons are properly placed within the dialog.<br />
        In order to make the buttons work correctly, you have to pass through 2 additional props, which is the form name
        and the submitting variable.<br />
        Look at the code to see how it is done.
    </>
  )
}
